export default __webpack_public_path__ + "static/media/twitter-logo-transparent-white.ba3e0cab.png";